(function () {
  if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

  var observed = new WeakSet();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('nico-swap-active', entry.isIntersecting);
    });
  }, { threshold: 0.55 });

  function setup() {
    document.querySelectorAll('.grid-view-item-image').forEach(function (card) {
      if (observed.has(card)) return;
      if (!card.querySelector('.product-card__image--secondary')) return;
      observed.add(card);
      observer.observe(card);
    });
  }

  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
  document.addEventListener('recommendations:loaded', setup);
  document.addEventListener('recentlyViewed:loaded', setup);
})();
